import { WRStatus } from "../../local_modules/voyage-suggested-routes/src/helper";
import { BaseModel } from "./base-model";
import { VoyageRoute, WeatherRoutingInfo } from "./voyage-routing-model";

export abstract class VoyageWeatherRoutingModelBase extends BaseModel
{
  abstract getWRAdvice(scheduleId: string): Promise<VoyageRoute | null>;
  abstract getWRStatus(departureTerminalCode: string, arrivalTerminalCode: string, scheduleId: string): Promise<any>;
  abstract updateWRStatus(WrId: string, status: WRStatus, weatherRoutingInfo: WeatherRoutingInfo): Promise<any>;
  abstract checkWrAvailability() : Promise<any>;
  abstract getWrStatusByScheduleId(scheduleId: string): boolean;
  abstract getWRPdf(id: string): Promise<any>;
  abstract checkIfPdfisAvailable(departureTerminalCode: string): Promise<string|null>;
  abstract showWrPdf(wrId: string): Promise<any>;
  abstract getWRProgress(auditId: string): Promise<any>;
  abstract hasWRAdviseForSchedule(scheduleId: string): Promise<boolean>;
}

let VoyageWeatherRoutingModel: VoyageWeatherRoutingModelBase|null = null;

function setVoyageWeatherRoutingModel(model: VoyageWeatherRoutingModelBase)
{
    VoyageWeatherRoutingModel = model;
}

export { VoyageWeatherRoutingModel, setVoyageWeatherRoutingModel };